import { makeObservable, observable } from 'mobx';

import { CollectionType, toBaseProductType } from '@/collection/entity/CollectionType';
import { DriveItemPreview } from '@/drive/entities/DriveItem/DriveItemPreview';
import { DriveItemId } from '@/drive/entities/DriveItemId';
import { DriveNode } from '@/drive/entities/DriveNode';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';

import { BaseCollectionItem } from './BaseCollectionItem';
import { BaseDriveItem, DriveItemType } from './DriveItem.types';
import { ProductItem } from './ProductItem';

export interface CollectionItemModel {
  id: DriveItemId;
  title: string;
  type: DriveItemType.Collection;
  description?: string;
  preview?: Nullable<DriveItemPreview>;
  canEdit: boolean;
  canManageAccess: boolean;
  collectionType: CollectionType;
  collectionId?: string;
  count: number;
  createdAt?: string;
  access: GlobalAccessLevel;
  dataAccess: ProjectDataAccess;
}

export class CollectionItem extends BaseCollectionItem {
  access: GlobalAccessLevel;

  dataAccess: ProjectDataAccess;

  constructor(model: CollectionItemModel) {
    super(model);

    makeObservable(this, {
      access: observable,
      dataAccess: observable,
    });

    this.access = model.access;
    this.dataAccess = model.dataAccess;
  }

  override isContainer() {
    return true;
  }

  override canContainItem(item: BaseDriveItem) {
    if (!(item instanceof ProductItem) || !item.productType || !this.collectionType) {
      return false;
    }

    return item.productType === toBaseProductType(this.collectionType);
  }

  toNode(): DriveNode {
    return {
      id: this.id,
      type: DriveItemType.Collection,
      title: this.title,
      count: this.count,
      collectionType: this.collectionType,
      collectionId: this.collectionId,
      description: this.description,
      access: this.access,
      dataAccess: this.dataAccess,
      canEdit: this.canEdit,
      canManageAccess: this.canManageAccess,
    };
  }
}
